import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-campaign-final-order',
  templateUrl: './campaign-final-order.component.html',
  styleUrls: ['./campaign-final-order.component.css']
})
export class CampaignFinalOrderComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/campaign/campaign-final-order/campaign-final-order.component.ts